import { Component } from "react"
import { PropTypes } from "prop-types"
import classNames from "classnames"

import Translate from "../Translate"
import { formatDate, formatDateTime, standardFormatDateTime } from "../../time"

export class DateTime extends Component {
  getFormatDate(date) {
    const { formatTo, formatFrom = standardFormatDateTime, showTimeByDef = false } = this.props

    return showTimeByDef
      ? formatDateTime(date, formatFrom, formatTo, true)
      : formatDate(date, formatFrom, formatTo)
  }

  renderDate() {
    const { dates, message } = this.props

    return (
      <span className="date">
        {message ? (
          <Translate id={message} data={{ date: this.getFormatDate(dates[0]) }} />
        ) : (
          this.getFormatDate(dates[0])
        )}
      </span>
    )
  }

  renderRangeDates() {
    const { dates, message } = this.props

    return (
      <span className="dates-range">
        {message ? (
          <Translate
            id={message}
            data={{
              date: this.getFormatDate(dates[0]),
              dateTwo: this.getFormatDate(dates[1])
            }}
          />
        ) : (
          this.getFormatDate(dates[0]) + this.getFormatDate(dates[1])
        )}
      </span>
    )
  }

  render() {
    const { dates, className, ariaHidden } = this.props

    return (
      <div className={classNames("oj-date-time", className)} aria-hidden={ariaHidden}>
        {dates.length > 1 ? this.renderRangeDates() : this.renderDate()}
      </div>
    )
  }
}

DateTime.propTypes = {
  className: PropTypes.string,
  dates: PropTypes.array.isRequired,
  formatFrom: PropTypes.string,
  formatTo: PropTypes.string,
  message: PropTypes.string,
  showTimeByDef: PropTypes.bool,
  ariaHidden: PropTypes.bool
}

export default DateTime
